var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"complete"},[_c('img',{attrs:{"src":require("../../assets/complete-01.png"),"alt":""}}),_c('div',[_vm._v("恭喜您，完成注册")])])
}]

export { render, staticRenderFns }